"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Tile;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const ThemeContext_1 = require("../ThemeContext");
const Theme_1 = require("../Theme");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        button: {
            alignItems: 'center',
            backgroundColor: THEME.CardBackground,
            borderColor: THEME.CardBorder,
            borderWidth: 1,
            borderBottomWidth: 2,
            borderRadius: 4,
            justifyContent: 'center',
            padding: 8,
            flex: 1
        }
    });
};
function Tile(props) {
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { style: ({ pressed }) => [
            { alignItems: 'center', justifyContent: 'center' },
            styles.button,
            props.style,
            ((pressed && !props.disabled) ? (props.pressedStyle ?? STYLES.pressed) : null)
        ], accessible: true, "aria-label": props["aria-label"], accessibilityHint: props.accessibilityHint, disabled: props.disabled, onPress: props.disabled ? (() => null) : props.onPress, children: [props.cornerIcon &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { position: 'absolute', top: 8, right: 8 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: `${THEME.Text}66`, size: 12, icon: props.cornerIcon }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignSelf: 'stretch',
                    alignItems: 'center',
                    paddingVertical: 6,
                    paddingHorizontal: 6
                }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: props.disabled ? THEME.TextDisabled : THEME.Secondary, size: size == 'lg' || size == 'xl' ? 28 : 20, icon: props.icon }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 2, ellipsizeMode: "tail", style: {
                            fontSize: size == 'lg' || size == 'xl' ? 16 : 14,
                            color: props.disabled ? THEME.TextDisabled : THEME.Text,
                            marginTop: 6,
                            userSelect: 'none',
                            includeFontPadding: false,
                            textAlign: 'center'
                        }, children: props.title })] })] }));
}
;
